module.exports = ".inside-content {\r\n    width: 100%;\r\n    background-color: gainsboro;\r\n    height: 400px;\r\n    overflow-x: scroll;\r\n}\r\nlabel{\r\n    color:#4285f4;\r\n    font-size: 14px;\r\n\r\n}\r\n.background-margin .row{\r\n    margin: 5px 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/schedule-report/schedule-report.component.css
// module id = ./src/app/reports/schedule-report/schedule-report.component.css
// module chunks = main